export const PAYMENT_SETTING_LOAD_REQUEST = 'PAYMENT_SETTING_LOAD_REQUEST';
export const PAYMENT_SETTING_LOAD_SUCCESS = 'PAYMENT_SETTING_LOAD_SUCCESS';
export const PAYMENT_SETTING_LOAD_FAILURE = 'PAYMENT_SETTING_LOAD_FAILURE';
